import { render, staticRenderFns } from "./CatastroComponent.vue?vue&type=template&id=914849c6&scoped=true&"
import script from "./CatastroComponent.vue?vue&type=script&lang=js&"
export * from "./CatastroComponent.vue?vue&type=script&lang=js&"
import style0 from "./CatastroComponent.vue?vue&type=style&index=0&id=914849c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914849c6",
  null
  
)

export default component.exports